import { createContext } from 'react';

import { UserTypes } from './UserTypes';

export type ExternalShareContextType = {
	isExternalShareRequest: boolean;
	userType: UserTypes;
	shareToken?: string;
};

export const ExternalShareContext = createContext<ExternalShareContextType>({
	isExternalShareRequest: false,
	userType: UserTypes.ANONYMOUS,
	shareToken: undefined,
});
